<template>
  <div class="workout-legacy-timer__wrapper">
    <div class="workout-legacy-timer__element">
      <h6 class="workout-legacy-timer__title mb-0 mt-0">
        Level
      </h6>
      <div class="workout-legacy-timer__time">
        {{ levelNumber }}
      </div>
    </div>
    <div class="workout-legacy-timer__element --small">
      <h6 class="workout-legacy-timer__title mb-0 mt-0">
        Distance
      </h6>
      <div class="workout-legacy-timer__time">{{ cumulativeDistance }}m</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeGroup: { type: Object, required: true }
  },

  data() {
    return {
      cumulativeDistance: 0
    }
  },

  computed: {
    levelNumber() {
      return this.activeGroup.title.replace("Level ", "")
    }
  },

  watch: {
    levelNumber(level, prevLevel) {
      if (parseFloat(level) > parseFloat(prevLevel)) {
        this.cumulativeDistance += 20
      }
    }
  }
}
</script>
